// extracted by mini-css-extract-plugin
export default {"mertics":"ImpactMetrics_mertics__OE9VS"};